'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes$1 = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var get = _interopDefault(require('lodash/get'));
var _babelHelpers = require('./_babelHelpers-48e7a7f7.js');
var findIndex = _interopDefault(require('lodash/findIndex'));

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  color: #aaaaaa;\n  font-family: Source Sans Pro, sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  font-style: normal;\n  margin: ", ";\n  ", "\n  ", "\n  @media (max-width: 767px) {\n    margin: ", ";\n  }\n"], ["\n  color: #aaaaaa;\n  font-family: Source Sans Pro, sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  font-style: normal;\n  margin: ", ";\n  ", "\n  ", "\n  @media (max-width: 767px) {\n    margin: ", ";\n  }\n"]),
    _templateObject2 = _babelHelpers.taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  position: relative;\n  overflow: hidden;\n  &:before {\n    height: 5px;\n    content: \"\";\n    background-color: #e5e5e5;\n    width: 100%;\n    display: block;\n    position: absolute;\n    top: 0px;\n    left: 0;\n  }\n\n  &:after {\n    height: 5px;\n    content: \"\";\n    background-color: ", ";\n    display: block;\n    position: absolute;\n    top: 0px;\n    left: ", "%;\n    width: ", "%;\n    transition: left 1s;\n    animation-name: leftSlow;\n    animation-duration: 1s;\n  }\n  @keyframes leftSlow {\n    from {\n      left: -100%;\n    }\n  }\n"], ["\n  width: 100%;\n  display: flex;\n  position: relative;\n  overflow: hidden;\n  &:before {\n    height: 5px;\n    content: \"\";\n    background-color: #e5e5e5;\n    width: 100%;\n    display: block;\n    position: absolute;\n    top: 0px;\n    left: 0;\n  }\n\n  &:after {\n    height: 5px;\n    content: \"\";\n    background-color: ", ";\n    display: block;\n    position: absolute;\n    top: 0px;\n    left: ", "%;\n    width: ", "%;\n    transition: left 1s;\n    animation-name: leftSlow;\n    animation-duration: 1s;\n  }\n  @keyframes leftSlow {\n    from {\n      left: -100%;\n    }\n  }\n"]),
    _templateObject3 = _babelHelpers.taggedTemplateLiteral(["\n  width: ", "%;\n  position: relative;\n  padding: ", ";\n  text-align: center;\n  ", ";\n  &:before {\n    height: 5px;\n    width: 2px;\n    content: \"\";\n    background-color: #ffff;\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    z-index: 1;\n  }\n  &:last-child {\n    &:before {\n      width: 0px;\n    }\n  }\n\n  @media (max-width: 767px) {\n    > span {\n      display: none;\n    }\n  }\n"], ["\n  width: ", "%;\n  position: relative;\n  padding: ", ";\n  text-align: center;\n  ", ";\n  &:before {\n    height: 5px;\n    width: 2px;\n    content: \"\";\n    background-color: #ffff;\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    z-index: 1;\n  }\n  &:last-child {\n    &:before {\n      width: 0px;\n    }\n  }\n\n  @media (max-width: 767px) {\n    > span {\n      display: none;\n    }\n  }\n"]),
    _templateObject4 = _babelHelpers.taggedTemplateLiteral(["\n  margin-top: -15px;\n  margin-left: 20px;\n  margin-bottom: ", ";\n  color: ", ";\n  @media (min-width: 767px) {\n    display: none;\n  }\n"], ["\n  margin-top: -15px;\n  margin-left: 20px;\n  margin-bottom: ", ";\n  color: ", ";\n  @media (min-width: 767px) {\n    display: none;\n  }\n"]);

var colorCurrentStepDefault = "#3b99fc";
var StepWrapper = styled__default.div(_templateObject, function (props) {
  return props.margin ? props.margin : "0px 0px";
}, function (props) {
  return props.desktopMaxWidth && "max-width:" + props.desktopMaxWidth + ";";
}, function (props) {
  return props.mobileMaxWidth && "@media (max-width:767px) {max-width:" + props.mobileMaxWidth + "};";
}, function (props) {
  return props.marginMobile ? props.marginMobile : "0px 0px";
});

var Steps = styled__default.div(_templateObject2, function (props) {
  return props.colorCurrentStep ? props.colorCurrentStep : colorCurrentStepDefault;
}, function (props) {
  return props.left >= 0 ? props.left : "-100";
}, function (props) {
  return props.width ? props.width : "25";
});

var Step = styled__default.div(_templateObject3, function (props) {
  return props.width ? props.width : "25";
}, function (props) {
  return props.padding ? props.padding : "15px 10px";
}, function (props) {
  return props.current && "color: " + (props.colorCurrentStep ? props.colorCurrentStep : colorCurrentStepDefault);
});
var TextMobile = styled__default.div(_templateObject4, function (props) {
  return props.textMobileMB ? props.textMobileMB : "30px";
}, function (props) {
  return props.colorCurrentStep ? props.colorCurrentStep : colorCurrentStepDefault;
});
/* stylelint-enable selector-type-no-unknown */

var StepProgress = function (_Component) {
  _babelHelpers.inherits(StepProgress, _Component);

  function StepProgress() {
    _babelHelpers.classCallCheck(this, StepProgress);
    return _babelHelpers.possibleConstructorReturn(this, (StepProgress.__proto__ || Object.getPrototypeOf(StepProgress)).apply(this, arguments));
  }

  _babelHelpers.createClass(StepProgress, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          steps = _props.steps,
          margin = _props.margin,
          colorCurrentStep = _props.colorCurrentStep,
          marginMobile = _props.marginMobile,
          stepPadding = _props.stepPadding,
          currentStep = _props.currentStep,
          desktopMaxWidth = _props.desktopMaxWidth,
          mobileMaxWidth = _props.mobileMaxWidth,
          textMobileMB = _props.textMobileMB;


      var length = get(steps, "length");
      var stepWidth = 100 / length;
      var currentIndex = findIndex(steps, function (s) {
        return s.key === currentStep;
      });
      var left = currentIndex * stepWidth;
      return React__default.createElement(
        StepWrapper,
        {
          desktopMaxWidth: desktopMaxWidth,
          mobileMaxWidth: mobileMaxWidth,
          margin: margin,
          marginMobile: marginMobile },
        React__default.createElement(
          Steps,
          {
            left: left,
            width: stepWidth,
            colorCurrentStep: colorCurrentStep },
          steps.map(function (s, i) {
            return React__default.createElement(
              Step,
              {
                width: stepWidth,
                key: s.key,
                current: s.key === currentStep,
                padding: stepPadding,
                colorCurrentStep: colorCurrentStep },
              React__default.createElement(
                "span",
                null,
                i + 1,
                ". ",
                s.title
              )
            );
          })
        ),
        React__default.createElement(
          TextMobile,
          {
            textMobileMB: textMobileMB,
            colorCurrentStep: colorCurrentStep },
          "Step ",
          currentIndex + 1,
          " of ",
          length,
          ":",
          " ",
          get(steps, currentIndex + ".title")
        )
      );
    }
  }]);
  return StepProgress;
}(React.Component);

StepProgress.propTypes = {
  /** steps progress bar */
  steps: PropTypes$1.array,
  /** current step by id */
  currentStep: PropTypes$1.string,
  /** panel margin */
  margin: PropTypes$1.string,
  /** panel margin by mobile */
  marginMobile: PropTypes$1.string,
  /** step padding */
  stepPadding: PropTypes$1.string,
  /** color active */
  colorCurrentStep: PropTypes$1.string
};
StepProgress.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "StepProgress",
  "props": {
    "steps": {
      "type": {
        "name": "array"
      },
      "required": false,
      "description": "steps progress bar"
    },
    "currentStep": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "current step by id"
    },
    "margin": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "panel margin"
    },
    "marginMobile": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "panel margin by mobile"
    },
    "stepPadding": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "step padding"
    },
    "colorCurrentStep": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "color active"
    }
  }
};

exports.Step = Step;
exports.StepWrapper = StepWrapper;
exports.Steps = Steps;
exports.TextMobile = TextMobile;
exports.default = StepProgress;
//# sourceMappingURL=step-progress.js.map
